import LoginPassword         from "../../../domain/authentication/LoginPassword";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import Error                 from "../../../domain/fundamentals/message/error/Error";
import ErrorMessage          from "../../../domain/fundamentals/message/error/ErrorMessage";
import ErrorRepository       from "../../../domain/fundamentals/message/error/ErrorRepository";
import Errors                from "../../../domain/fundamentals/message/error/Errors";
import ErrorTarget           from "../../../domain/fundamentals/message/error/ErrorTarget";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import StaffId               from "../../../domain/staff/StaffId";
import StaffRepository       from "../../../domain/staff/StaffRepository";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import ErrorDataSource       from "../../../infrastructure/datasource/error/ErrorDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import StaffDataSource       from "../../../infrastructure/datasource/staff/StaffDataSource";

class ChangeStaffPassword {
  constructor(
    private readonly dispatch,
    private readonly staffRepository: StaffRepository = new StaffDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
    private readonly errorRepository: ErrorRepository = new ErrorDataSource(dispatch),
  ) {
  }

  public async execute(staffId: StaffId, currentPassword: LoginPassword, newPassword: LoginPassword, confirmPassword: LoginPassword, callback: (value: boolean) => void) {
    this.fetchStatusRepository.start();
    try {
      await this.staffRepository.changePassword(staffId, currentPassword, newPassword, confirmPassword);
      callback(false);
      this.notifyRepository.saveSuccess();
    } catch (e) {
      const list: Error[] = e.response.data.errors.map(error => new Error(new ErrorTarget(error.target), new ErrorMessage(error.message)));
      this.errorRepository.set(new Errors(list));
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default ChangeStaffPassword;
